import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ValidationService } from './../../validation.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from './../../_services/index';
import { FormDoneService } from '../../_services/form-done.service';
import { AuthenticationService } from './../../_services/index';
import { Subscription } from 'rxjs/Subscription';
import { CookieService } from 'ngx-cookie';
import * as jwt_decode from 'jwt-decode';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
  providers: [UserService, FormDoneService, AuthenticationService]
})
export class SignupComponent implements OnInit, OnDestroy {
  ErrorMassage: any;
  signUpForm: any;
  public errorFlag = false;
  loading = false;
  getdataSub: Subscription;
  signUpSub: Subscription;
  loginSub: Subscription;
  invalidEmail = false;
  disabledSubmit = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private userservice: UserService,
    private api: FormDoneService,
    private loginservice: AuthenticationService,
    private _cookieService: CookieService
  ) { }

  ngOnInit() {
    this.validateSignUpForm();
  }

  validateSignUpForm() {
    this.signUpForm = this.formBuilder.group({
      'email': ['', [Validators.required]],
      'password': ['', [
        Validators.required,
      ]],
      'confirm_password': ['', [
        Validators.required,
      ]],
      'firstname': ['', [
        Validators.required,
        ValidationService.noSpaceValidator,
      ]],
      'lastname': ['', [
        Validators.required,
        ValidationService.noSpaceValidator,
      ]],
      'username': ['', [
        Validators.required,
        ValidationService.noSpaceValidator,
      ]]
    });
  }

    checkEmail() {
        if (this.signUpForm.controls['email'].invalid) {
          this.invalidEmail = true;
        } else {
            this.invalidEmail = false;
        }
    }

  signUpUser() {
      this.loading = true;
      this.disabledSubmit = true;
      this.signUpSub = this.userservice.signup(
        this.signUpForm.value.email, this.signUpForm.value.password,
        this.signUpForm.value.confirm_password, this.signUpForm.value.firstname,
        this.signUpForm.value.lastname, this.signUpForm.value.username
      ).subscribe(
        (dataResponse) => {
          const response = dataResponse;
          if (response.success === 1 && response.statusCode === 200) {
            this.errorFlag = false;
            this.loading = false;
            this.disabledSubmit = false;
            this.ErrorMassage = response.message;
            this.loginUser(this.signUpForm.value.email, this.signUpForm.value.password);
            this.signUpForm.reset({
              'email': '',
              'password': '',
              'confirm_password': '',
              'firstname': '',
              'lastname': '',
              'username': ''
            });
          }
        },
        error => {
          this.loading = false;
          this.disabledSubmit = false;
          let errordata = error;
          if (this.isJSON(error._body)) {
            errordata = JSON.parse(error._body);
          } else {
            errordata = error;
          }
          if (errordata.success === 0) {
            this.ErrorMassage = errordata.message;
            this.errorFlag = true;
          }
        }
      );
  }

  loginUser(email, password) {
    this.loading = true;
    this.loginSub = this.loginservice.authenticate(
      email, password
    ).subscribe(
      (dataResponse) => {
        const response = dataResponse;
        if (response.success === 1 && response.statusCode === 200) {
          this.errorFlag = false;
          localStorage.setItem('currentUser', JSON.stringify(response.data));
          const token = response.data.token;
          localStorage.setItem('token', 'Bearer ' + token);
          this.errorFlag = false;
          this.loading = false;
          /* Code Block for Cookie generate functionality */

          const decoded = jwt_decode(token);
          const exp = decoded.exp;
          const date = new Date(exp * 1000);
          const getDomainName = this.loginservice.getDomainName();
          const parts = window.location.hostname.split(getDomainName);

          const countLength = parts.length;

          const subdomain = parts.shift();
          if (countLength === 1) {
            this._cookieService.put('token', 'Bearer ' + token, {
              domain: getDomainName,
              expires: date
            });
          }
          if (countLength === 2) {
            this._cookieService.put('token', 'Bearer ' + token, {
              domain: getDomainName,
              expires: date
            });
          }

          /* Code Block for Cookie generate functionality */
          this.getdataSub = this.api.getFormData('Bearer ' + token)
          .subscribe(responsedata => {
            const formdata = responsedata.data;
            const personalinformation = formdata.personalinformation;
            const academicinformation = formdata.academicinformation;
            const backgroundinformation = formdata.backgroundinformation;
            const priorhighereducation = formdata.priorhighereducation;
            const futurecollegeplans = formdata.futurecollegeplans;
            const academiccareergoals = formdata.academiccareergoals;
            const extracurrucaullar = formdata.extracurrucaullar;
            const employment = formdata.employment;
            if (
              (personalinformation > 0) ||
              (academicinformation > 0) ||
              (backgroundinformation > 0) ||
              (priorhighereducation > 0) ||
              (futurecollegeplans > 0) ||
              (academiccareergoals > 0) ||
              (extracurrucaullar > 0) ||
              (employment > 0)
            ) {
              this.router.navigate(['/user-dashboard']);
            } else {
              this.router.navigate(['/profile-upload']);
            }
          });
        }
      },
      error => {
        this.loading = false;
        console.log(error);
        let errordata = error;
        if (this.isJSON(error._body)) {
          errordata = JSON.parse(error._body);
        } else {
          errordata = error;
        }
        if (errordata.success === 0) {
          this.ErrorMassage = errordata.message;
          this.errorFlag = true;
        }
      }
    );
  }

  isJSON(str) {
    try {
      return (JSON.parse(str) && !!str);
    } catch (e) {
      return false;
    }
  }

  ngOnDestroy() {
    if (this.signUpSub) {
      this.signUpSub.unsubscribe();
    }
    if (this.loginSub) {
      this.loginSub.unsubscribe();
    }
    if (this.getdataSub)  {
      this.getdataSub.unsubscribe();
    }
  }


}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/signup/signup.component.ts